import { TENANT } from '../../../tenant'

const hidePackSizeSelectorForExpas = new Set([
  'ads',
  'bil',
  'con',
  'def1',
  'def2',
  'def3',
  'doo',
  'gglp',
  'gue',
  'ide',
  'kel',
  'lad',
  'ovtp',
  'prez',
  'sho',
  'shof',
  'shp',
  'tro',
])

const chHidePackSizeSelectorForExpas = new Set([
  'ads',
  'bil',
  'com',
  'de1',
  'de2',
  'de3',
  'doo',
  'gglp',
  'gue',
  'kel',
  'ovtp',
  'pre',
  'shof',
  'shop',
])

/**
 * Checks whether the PDP should hide pack-size selector controls for visitors
 * entering through tenant-specific Expa channels.
 */
export const productPageExpaShouldHidePackSizeSelector = ({
  expa,
  tenant,
}: {
  expa: string | null
  tenant: TENANT
}): boolean => {
  if (!expa) {
    return false
  }

  if (tenant === TENANT.CH) {
    return chHidePackSizeSelectorForExpas.has(expa)
  }

  if (tenant === TENANT.FR || tenant === TENANT.IT) {
    return hidePackSizeSelectorForExpas.has(expa)
  }

  return false
}
